var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83154 37.2133L5.83197 14.1049C5.83201 12.382 7.50051 11.1517 9.14641 11.6609V11.6609C14.5346 13.3279 20.3599 13.3279 25.748 11.6609C31.638 9.83865 38.0332 10.0131 43.7977 12.1532L44.5493 12.4323L44.5489 38.2083C44.5488 38.5968 44.1614 38.8662 43.7972 38.731V38.731C38.0327 36.5909 31.6375 36.4164 25.7476 38.2387C20.3594 39.9057 14.5341 39.9057 9.14591 38.2387L5.83154 37.2133Z",
    stroke: "#4B4B4B",
    strokeWidth: 2.74248,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0299 24.9296C30.0299 27.6025 27.8631 29.7693 25.1902 29.7693C22.5173 29.7693 20.3505 27.6025 20.3505 24.9296C20.3505 22.2568 22.5173 20.09 25.1902 20.09C27.8631 20.09 30.0299 22.2568 30.0299 24.9296Z",
    stroke: "#4B4B4B",
    strokeWidth: 2.74248,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankNote);
export default __webpack_public_path__ + "static/media/bank-note.75c7b677e83689f80ceb267946b33149.svg";
export { ForwardRef as ReactComponent };